import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Home from './components/Home'
import Game from './Game'

const App = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route index element={<Home />} />
                <Route element={<Game />} path='/game' />
            </Routes>
        </BrowserRouter>
    )
}

export default App